/**
 * rest 请求配置
 */
import ajax from '../common/ajax'
export default {
  // auth: {
  //   weixin: ajax.query('/auth/weixin')
  // },
  // veri: {
  //   // requestVeriCode: ajax.create('/verification_code'),
  //   activate: ajax.create('/active')
  // },
  // // 质检报告
  // report: {
  //   getQreport: ajax.query('')
  // },
  // me: {
  //   bidder: {
  //     my_bided: ajax.query('/me/bidder/my_bided?count=200'),
  //     my_buyed: ajax.query('/me/bidder/my_buyed?count=200'),
  //     detail: ajax.query('/me/bidder/detail')
  //   }
  // },
  // bidder: {
  //   detail: ajax.query('/bidder'),
  //   bid: ajax.create('/bidder/bid'),
  //   list: ajax.query('/bidder/list'),
  //   check_status: ajax.query('/bidder'),
  //   rule: ajax.query('/bidder')
  // },
  personal: {
    checkAuth: ajax.query('/check_login_status', { baseUrl: '/auth' }),
    getMsmCode: ajax.create('/verification_code', { baseUrl: '/auth' }),
    login: ajax.create('/login', { baseUrl: '/auth' })
  },
  dataReport: {
    getCalendarData: ajax.query('/report/list_calendar_date'),
    // 日详情
    dailyDetails: ajax.query('/report/daily_details'),
    // 月详情
    monthlyDetail: ajax.query('/report/monthly_details'),
    // 数据上报
    create: ajax.create('/report/create'),
    // 编辑
    edit: id => ajax.patch(`/report/edit/${id}`)
  }
}



// WEBPACK FOOTER //
// ./src/rest/config.js